import React from 'react';
import I18n from 'i18n-js';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import { RCCallout, RCButtonLink, RCText } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';
import PiggyBank from '../../../images/piggy-bank.svg';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
import { REVERB_PAYMENTS_EXPANSION_ARTICLE_ID } from '@reverbdotcom/commons/src/constants';

export default function ReverbPaymentsExpansionEarningsBanner() {
  const articleUrl = useHelpCenterArticleUrl(REVERB_PAYMENTS_EXPANSION_ARTICLE_ID);

  return (
    <div className="reverb-payments-expansion-earnings-banner">
      <RCCallout
        themeType="tempo"
        variant="tweed-mid-vu"
        image={PiggyBank}
        title={I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.title')}
        cta={(
          <RCButtonLink
            variant="dark"
            renderLink={c => (
              <CoreLink to={Paths.shopPoliciesEdit.expand({})} target="_blank" rel="noopener noreferrer">{c}</CoreLink>
            )}
          >
            {I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.updatePayoutSettings')}
          </RCButtonLink>
        )}
      >
        <p>
          <I18N text="discovery.reverbPaymentsExpansionEarningsBanner.subtitle">
            <a href={articleUrl} target="_blank" className="text-link" rel="noopener noreferrer">
              {I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.learnMore')}
            </a>
          </I18N>
        </p>
        <span className="mobile-d-none">
          <RCText.Fine>
            {I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.finePrint')}
          </RCText.Fine>
        </span>
      </RCCallout>
    </div>
  );
}
